'use client'

import Image from 'next/image'
import { toNumber } from '@helium/spl-utils'
import { BN } from '@coral-xyz/anchor'
import { PublicKey } from '@solana/web3.js'
import { useAsync } from 'react-async-hook'
import { getRewardsForNFT } from '@dewicats/auction-manager-sdk'
import { useSolana } from '@dewicats/connect-button'
import { tokenByMint } from '@data/tokens'
import SimpleSpinner from '@components/SimpleSpinner'
import { useMint2022 } from '@hooks/useOwnedAmount2022'
import { NATIVE_MINT } from '@solana/spl-token'

const RewardAmountText = ({
  listingEnded,
  recipient,
  listing,
  mint,
}: {
  listingEnded: boolean
  recipient: PublicKey
  listing: PublicKey
  mint: PublicKey
}) => {
  const { anchorProvider } = useSolana()
  const { info } = useMint2022(
    mint.toBase58() === NATIVE_MINT.toBase58() ? undefined : mint,
  )

  const { result: rewards } = useAsync(async () => {
    return getRewardsForNFT(recipient, listing, anchorProvider)
  }, [recipient, listing, anchorProvider])

  const token = tokenByMint(mint)

  if (!listingEnded) {
    return (
      <div className="flex">
        <SimpleSpinner />
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2">
      {token?.logo && (
        <Image
          src={token.logo}
          alt={token.symbol}
          width={20}
          height={20}
          data-loaded="false"
          onLoad={(event) => {
            event.currentTarget.setAttribute('data-loaded', 'true')
          }}
          className={`data-[loaded=false]:animate-pulse data-[loaded=false]:bg-dark-7`}
        />
      )}
      <p>
        {rewards &&
        (info?.decimals || listing?.toBase58() === NATIVE_MINT.toBase58()) ? (
          toNumber(new BN(rewards), info?.decimals || 9).toLocaleString()
        ) : (
          <SimpleSpinner />
        )}
      </p>
    </div>
  )
}

export default RewardAmountText
